import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M198 69.1V100c0 25.6-43.9 46.4-98 46.4S2 125.6 2 100V69.1c0 25.6 43.9 46.4 98 46.4s98-20.8 98-46.4zM2 120.6c0 25.6 43.9 46.4 98 46.4s98-20.8 98-46.4v30.9c0 25.6-43.9 46.4-98 46.4S2 177.1 2 151.5v-30.9zm98-25.8C45.9 94.8 2 74 2 48.4S45.9 2 100 2s98 20.8 98 46.4-43.9 46.4-98 46.4z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}